import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { useSelector } from 'reduxState/store';

const Wrapper = styled.div<{ $maxWidth?: string }>`
  position: relative;
  padding: 0 24px;
  ${props => (props.$maxWidth ? `max-width: ${props.$maxWidth};` : '')}
  font-size: var(--medium);
  > h1 {
    text-align: left;
  }
`;

const WrapperMobile = styled.div<{ $maxWidth?: string }>`
  padding: 20px 16px;
  ${props => (props.$maxWidth ? `max-width: ${props.$maxWidth};` : '')}
  font-size: var(--medium);
  text-align: left;
  > h1 {
    text-align: left;
  }
`;

interface PanelProps {
  title?: string;
  className?: string;
  children: ReactNode;
  maxWidth?: string;
  padding?: boolean;
}

const FeaturePanel = ({ title, children, maxWidth, className }: PanelProps) => {
  const isMobile = useSelector(state => state.screen.isMobile);

  return isMobile ? (
    <WrapperMobile $maxWidth={maxWidth} className={className}>
      {title && <h1>{title}</h1>}
      {children}
    </WrapperMobile>
  ) : (
    <Wrapper $maxWidth={maxWidth} className={className}>
      {title && <h1>{title}</h1>}
      {children}
    </Wrapper>
  );
};

export default FeaturePanel;
